import React from "react";
import { Link } from "./L";
import { Gift, ArrowRight } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const CTABand = ({ city }) => {
  const { t } = useLang();
  return (
    <section className="bg-teal-700">
      <div className="max-w-[1200px] mx-auto px-5 md:px-6 py-16 md:py-20 text-center">
        <div className="inline-flex items-center gap-2 bg-amber-400 text-teal-800 font-semibold text-sm px-4 py-1.5 rounded-full mb-6">
          <Gift className="w-4 h-4" /> {t.cta.badge}
        </div>
        <h2 className="font-head font-extrabold text-white text-3xl md:text-5xl leading-tight mb-4">
          {city ? t.cta.titleCity(city) : t.cta.titleDefault}
        </h2>
        <p className="text-teal-100 text-lg max-w-2xl mx-auto mb-9">{t.cta.desc}</p>
        <Link to="/buchen" className="inline-flex items-center gap-2 bg-white text-teal-700 font-head font-bold text-lg px-8 py-4 rounded-xl hover:bg-teal-50 transition-colors shadow-lg">
          {t.cta.button} <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </section>
  );
};

export default CTABand;
